// extracted by mini-css-extract-plugin
export var imageGallery = "ImageGallery-module--image-gallery--1pzwi";
export var column = "ImageGallery-module--column--P-dwD";